import { css } from 'lit';

export const styles = css`:host{--disabled-item-text-color: var(--ig-dropdown-disabled-item-text-color, var(--ig-gray-300));--border-color: var(--ig-dropdown-border-color, var(--ig-gray-100))}`;
